import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/page/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/index',
      children: [{
        path: 'index',
        name: 'Index',
        component: () =>
          import('@/views/index')
      }]
    },
    {
      path: '/',
      component: Layout,
      redirect: '/index2',
      children: [{
        path: 'index2',
        name: 'Index2',
        component: () =>
          import('@/views/index/index2')
      }]
    },
    {
      path: '/detail',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'Detail',
          component: () => import('@/views/detail'),
        }
      ]
    },
    {
      path: '/order',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'Order',
          component: () => import('@/views/order'),
        }
      ]
    },
    {
      path: '/myGame',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'MyGame',
          component: () => import('@/views/myGame'),
        }
      ]
    },
    {
      path: '/issues',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'Issues',
          component: () => import('@/views/issues'),
        }
      ]
    },
    {
      path: '/customer',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'Customer',
          component: () => import('@/views/customer'),
        }
      ]
    },
    {
      path: '/payCallback',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'PayCallback ',
          component: () => import('@/views/payCallback'),
        }
      ]
    },
    {
      path: '/recharge',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'Recharge',
          component: () => import('@/views/recharge'),
        }
      ]
    },
    {
      path: '/introduce',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'Introduce',
          component: () => import('@/views/introduce'),
        }
      ]
    },
    {
      path: '/manhuang',
      component: () => import('@/views/manhuang'),
    },
    {
      path: '/callback',
      component: () => import('@/views/callback'),
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js